import { render, staticRenderFns } from "./SaveAsBtn.vue?vue&type=template&id=78d5a260&scoped=true&"
import script from "./SaveAsBtn.vue?vue&type=script&lang=ts&"
export * from "./SaveAsBtn.vue?vue&type=script&lang=ts&"
import style0 from "./SaveAsBtn.vue?vue&type=style&index=0&id=78d5a260&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78d5a260",
  null
  
)

export default component.exports